import styled from 'styled-components';
import TooltipBubble from './TooltipBubble';

const TooltipRight = styled(TooltipBubble)`
  top: ${({ locationTop }) => locationTop || '50%'};
  left: 100%;
  padding-left: 9px;
  transform: translateY(-50%);

  &::after {
    border-right: 9px solid rgba(0, 0, 0, 0.7);
    border-top: 9px solid transparent;
    border-bottom: 9px solid transparent;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
  }
`;

export default TooltipRight;
